// src/services/api.js

const API_BASE_URL = 'https://kajiadobrighthorizons.org/api';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`❌ API Error (${endpoint}):`, error);
    throw error;
  }
};

// ============================================
// DONATION API
// ============================================
export const donationApi = {
  // Save a donation to database
  save: (donationData) => apiCall('/donations', {
    method: 'POST',
    body: JSON.stringify(donationData),
  }),

  // Get all donations (admin only)
  getAll: () => apiCall('/donations', {
    method: 'GET',
  }),

  // Get donation by reference
  getByReference: (reference) => apiCall(`/donations/${reference}`, {
    method: 'GET',
  }),
};

// ============================================
// CONTACT FORM API
// ============================================
export const contactApi = {
  save: (contactData) => apiCall('/contact', {
    method: 'POST',
    body: JSON.stringify(contactData),
  }),
};

// ============================================
// VOLUNTEER API
// ============================================
export const volunteerApi = {
  save: (volunteerData) => apiCall('/volunteer', {
    method: 'POST',
    body: JSON.stringify(volunteerData),
  }),
};

// ============================================
// GIFT IN KIND API
// ============================================
export const giftInKindApi = {
  save: (giftData) => apiCall('/giftinkind', {
    method: 'POST',
    body: JSON.stringify(giftData),
  }),
};

// ============================================
// NEWSLETTER API
// ============================================
export const newsletterApi = {
  save: (newsletterData) => apiCall('/newsletter', {
    method: 'POST',
    body: JSON.stringify(newsletterData),
  }),
};

// ============================================
// VISIT REQUEST API
// ============================================
export const visitApi = {
  save: (visitData) => apiCall('/visit', {
    method: 'POST',
    body: JSON.stringify(visitData),
  }),
};

// ============================================
// M-PESA (DARaja) API
// ============================================
export const mpesaApi = {
  // Initiate STK Push
  stkPush: (data) => apiCall('/daraja/stkpush', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // Check transaction status
  checkStatus: (checkoutRequestID) => apiCall(`/daraja/status/${checkoutRequestID}`, {
    method: 'GET',
  }),

  // Get all stored transactions (debug)
  getTransactions: () => apiCall('/daraja/transactions', {
    method: 'GET',
  }),

  // SSE connection for real-time updates
  connectSSE: (checkoutRequestID) => {
    return new EventSource(`https://kajiadobrighthorizons.org/api/daraja/status-stream/${checkoutRequestID}`);
  },
};

// ============================================
// PESAPAL API
// ============================================
export const pesapalApi = {
  // Initiate payment
  initiate: (data) => apiCall('/payment/initiate', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // Check payment status
  checkStatus: (orderTrackingId) => apiCall(`/payment/status?orderTrackingId=${orderTrackingId}`, {
    method: 'GET',
  }),
};

// ============================================
// SYSTEM API
// ============================================
export const systemApi = {
  // Health check
  health: () => apiCall('/health', {
    method: 'GET',
  }),

  // Database test
  dbTest: () => apiCall('/db-test', {
    method: 'GET',
  }),

  // Debug token
  debugToken: () => apiCall('/debug/token', {
    method: 'GET',
  }),
};

// Default export for convenience
export default {
  donation: donationApi,
  contact: contactApi,
  volunteer: volunteerApi,
  giftInKind: giftInKindApi,
  newsletter: newsletterApi,
  visit: visitApi,
  mpesa: mpesaApi,
  pesapal: pesapalApi,
  system: systemApi,
};